export default "/assets/images/spring-air-slide-lg.bfa5c2a4bf8819a2.jpg";